import Axios, { AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { queryClient } from '@/lib/react-query';
import { router } from '@/main';
import { ROUTE_CONSTANTS } from '@/routes';

const baseUrl = process.env.NODE_ENV === 'development' ? '/api' : '';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: baseUrl,
  timeout: 10000,
});

function requestInterceptor(config: InternalAxiosRequestConfig) {
  config.headers.Accept = 'application/json';

  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}

function onFulfilled(
  value: AxiosResponse<any, any>
): AxiosResponse<any, any> | Promise<AxiosResponse<any, any>> {
  return value;
}

async function onRejected(error: Error): Promise<any> {
  if (Axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem('accessToken');
      queryClient.clear();
      void router.navigate({ to: ROUTE_CONSTANTS.LOGIN_PATH });
      return new Promise(() => {});
    }
  }
  return Promise.reject(error);
}

AXIOS_INSTANCE.interceptors.request.use(requestInterceptor);
AXIOS_INSTANCE.interceptors.response.use(onFulfilled, onRejected);

export const customAxios = <T>(config: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-expect-error - cancel is not part of the promise
  promise.cancel = () => {
    source.cancel('Query was cancelled by React Query');
  };

  return promise;
};
